export function isBot(userAgent: string = ''): boolean {
  return /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|rogerbot|linkedinbot|applebot|pingdom|ahrefsbot|semrushbot/i.test(userAgent);
}